import isEmail from 'validator/lib/isEmail';

import {isSettingEnabled} from './setting-enabled';

const isUndefinedEmptyOrWhitespace = (value) => !value || /^\s*$/.test(value);
const phoneRegex = /^\d{3}-?\d{3}-?\d{4}$/;
const specialValidatorsByField = {
    email: (email, fieldSetting) => {
        if (email && !isEmail(email)) {
            return `${fieldSetting.label} is not valid`;
        }

        return undefined;
    },
    phone: (phone, fieldSetting) => {
        if (phone && !phoneRegex.test(phone)) {
            return `${fieldSetting.label} is not valid`;
        }

        return undefined;
    }
};

const buildValidator = (fieldSetting) => (fieldValue) => {
    if (isSettingEnabled(fieldSetting.required) && isUndefinedEmptyOrWhitespace(fieldValue)) {
        return `${fieldSetting.label} is required`;
    }

    return undefined;
};

export default (eventFields, fieldSettings) => {
    const errors = {};

    Object.keys(fieldSettings)
        .filter((field) => isSettingEnabled(fieldSettings[field].show))
        .forEach((field) => {
            const fieldSetting = fieldSettings[field];
            const fieldValue = eventFields[field];

            const specialValidator = specialValidatorsByField[field]
                || (() => undefined);
            const validator = buildValidator(fieldSetting);
            const fieldErrors =
                specialValidator(fieldValue, fieldSetting)
                || validator(fieldValue);

            if (fieldErrors) {
                errors[field] = fieldErrors;
            }
        });

    if (Object.keys(errors).length !== 0) {
        return errors;
    }

    return undefined;
};



// WEBPACK FOOTER //
// ./src/event/validate.js